import { isBefore, parseISO } from 'date-fns';
export var connectStatus = function connectStatus(social) {
  return social.__typename === 'Linkedin' && !!social.connected && !!social.expiresAt && isBefore(parseISO(social.expiresAt), new Date()) ? 'Expired' : social.connected ? 'Connected' : 'Disconnected';
};